import React from 'react';
import { Flex, CardContent, Card, Checkbox, Text } from '@upsales/components';
import BemClass from '@upsales/components/Utils/bemClass';
import ProspectingClient from 'App/resources/Model/ProspectingClient';
import SoliditetClient from 'App/resources/Model/SoliditetClient';
import { useTranslation } from 'Components/Helpers/translate';
import NameProspecting from 'Components/Modals/CreateNewAccount/Columns/NameProspecting';
import ExistInUpsales from 'Components/Misc/ExistInUpsales';
import { CompanyRowAddType } from '../Add/Add';
import { AccountManagers, ClientColumnSubtitle } from '../columnParts';

import './CompanyRow.scss';

type CompanyRowOfficesType = {
	company: ProspectingClient | SoliditetClient;
	selected: boolean;
	isProspecting: boolean;
	onSelectCompany: (branchCompany: ProspectingClient | SoliditetClient) => void;
};

const classes = new BemClass('CompanyRow');

export const CompanyRowBranchOffices = ({
	company,
	selected,
	onSelectCompany,
	isProspecting
}: CompanyRowOfficesType) => {
	const { t } = useTranslation();

	return (
		<Card border="ts" borderColor="grey-4">
			<CardContent>
				<Flex alignItems="center" gap="u3">
					<Flex alignItems="center">
						<Checkbox checked={selected} size="sm" onClick={() => onSelectCompany(company)} />
					</Flex>
					<Flex flex={1}>
						<NameProspecting account={company} noTable />
					</Flex>
					<Flex alignItems="center">
						{isProspecting && (company as ProspectingClient).matchInUpsales ? (
							<ExistInUpsales client={(company as ProspectingClient).matchInUpsales as any} />
						) : (
							<Text className={classes.elem('notInUpsales').b()}>{t('default.notInUpsales')}</Text>
						)}
					</Flex>
				</Flex>
			</CardContent>
		</Card>
	);
};

export const CompanyRowAdd = ({ company, selected, onSelectCompany, cantRelate = false }: CompanyRowAddType) => {
	return (
		<Card border="ts" borderColor="grey-4">
			{cantRelate ? (
				<CardContent className={classes.elem('cantRelate').b()}>
					<Flex alignItems="center">
						<Flex flex={1}>
							<Flex direction="column">
								<Text color="grey-10">{company.name}</Text>
								<ClientColumnSubtitle client={company} color="grey-10" />
							</Flex>
						</Flex>
						<Flex gap="u3" direction="column">
							<AccountManagers users={company.users} skipPlaceHolder />
						</Flex>
					</Flex>
				</CardContent>
			) : (
				<CardContent>
					<Flex gap="u3" alignItems="center" justifyContent="space-between">
						<Flex gap="u3" direction="column" alignItems="center">
							<Checkbox checked={selected} size="sm" onClick={() => onSelectCompany(company)} />
						</Flex>
						<Flex flex={1}>
							<Flex direction="column">
								{company.name}
								<ClientColumnSubtitle client={company} />
							</Flex>
						</Flex>
						<Flex gap="u3" direction="column">
							<AccountManagers users={company.users} skipPlaceHolder />
						</Flex>
					</Flex>
				</CardContent>
			)}
		</Card>
	);
};
